// extracted by mini-css-extract-plugin
export var footer = "_m7-5";
export var fulfillmentInput = "_m7-0";
export var shipDateInput = "_m7-1";
export var shipmentModal = "_m7-2";
export var shipmentModalContent = "_m7-3";
export var tableContainer = "_m7-4";